import React from "react"
import { positionRight } from "@reach/popover"
import {
  Button,
  DropdownMenu,
  DropdownMenuPopover,
  DropdownMenuItemsLowLevel,
  DropdownMenuItem,
  DropdownMenuButton,
} from "gatsby-interface"
import { MdEdit, MdDeleteForever, MdMoreVert } from "react-icons/md"

export function CmsIntegrationDropdown({
  cms,
  cmsName = cms,
  onEdit,
  onDelete,
}) {
  return (
    <DropdownMenu>
      <Button
        ButtonComponent={DropdownMenuButton}
        data-cy={`edit-cms-integration-button-${cms}`}
        data-testid={`new-edit-cms-integration`}
        aria-label={`Actions for integration with ${cmsName}`}
        size="L"
        variant="GHOST"
        tone="BRAND"
      >
        <MdMoreVert />
      </Button>
      <DropdownMenuPopover position={positionRight}>
        <DropdownMenuItemsLowLevel size="MAX_CONTENT">
          <DropdownMenuItem onSelect={onEdit} Icon={MdEdit}>
            Edit
          </DropdownMenuItem>
          <DropdownMenuItem
            onSelect={onDelete}
            Icon={MdDeleteForever}
            tone="CRITICAL"
          >
            Delete
          </DropdownMenuItem>
        </DropdownMenuItemsLowLevel>
      </DropdownMenuPopover>
    </DropdownMenu>
  )
}
